import React from "react";
import ReactDOM from "react-dom/client";
import ContactForm from "./ContactForm";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ContactForm />
  </React.StrictMode>,
);
